/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/** Pure breadcrumb helpers for PageBreadcrumbs (kept import-free for tests). */

const SINGULAR_TO_LIST_ROUTE = {
  "travel-order": "/travel-orders",
  "travel-order-pax": "/travel-order-pax",
  "travel-invoice": "/travel-invoices",
  "travel-invoice-line-item": "/travel-invoice-line-items",
  "guide-trip-note": "/guide-trip-notes",
  "referral-code": "/referral-codes",
  creator: "/creators",
  "creator-onboarding": "/creator-onboardings",
  "guide-allocation": "/guide-allocations",
  customer: "/customers",
  opportunity: "/opportunities",
  coupon: "/coupons",
  "pricing-category": "/pricing-categories",
  "customer-coupon": "/customer-coupons",
  "loyalty-rule": "/loyalty-rules",
  "loyalty-ledger": "/loyalty-ledgers",
  "loyalty-summary": "/loyalty-summaries",
  "payment-transaction": "/payment-transactions",
  "payment-term": "/payment-terms",
  "training-completion": "/training-completions",
  "travel-contact": "/travel-contacts",
  "order-cancellation": "/order-cancellations",
  "order-comm": "/order-comms",
  "order-coupon": "/order-coupons",
  "order-itinerary": "/order-itineraries",
  merchant: "/merchants",
  "merchant-allocation": "/merchant-allocations",
  "merchant-order-line": "/merchant-order-lines",
  "merchant-asset-inventory": "/merchant-asset-inventories",
  "travel-order-item": "/travel-order-items",
};

/** route path -> display name, from routes.js entries (nested ones too), with app labels applied by route key. */
export function routeNameMap(routes, labels = {}) {
  const map = new Map();
  const walk = (list) =>
    (list || []).forEach((r) => {
      if (r?.route && r?.name && !map.has(r.route)) map.set(r.route, labels[r.key] || r.name);
      if (Array.isArray(r?.collapse)) walk(r.collapse);
    });
  walk(routes);
  return map;
}

function humanise(segment) {
  const text = decodeURIComponent(segment).replace(/[-_]/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}

/** [{label, to}] for a path; the last crumb has no link. */
export function breadcrumbsFor(pathname, routeNames) {
  const rawParts = pathname.split("/").filter(Boolean);
  const parts = [];
  for (let i = 0; i < rawParts.length; i += 1) {
    if (rawParts[i] === "detail" && i > 0 && i < rawParts.length - 1) {
      continue;
    }
    parts.push(rawParts[i]);
  }

  const crumbs = parts.map((part, i) => {
    let to = `/${parts.slice(0, i + 1).join("/")}`;
    if (i === 0 && SINGULAR_TO_LIST_ROUTE[part]) {
      to = SINGULAR_TO_LIST_ROUTE[part];
    }
    const label = routeNames.get(to) || (/^\d+$/.test(part) ? `#${part}` : humanise(part));
    return { label, to: routeNames.has(to) ? to : null };
  });
  if (crumbs.length) crumbs[crumbs.length - 1].to = null;
  return crumbs;
}
